import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

//const
import { QUERY_KEYS } from 'consts/queryKeys';
//custom hooks
import { useCustomToast } from 'hooks';
//services
import { updateReservationPaymentStatus } from 'modules/accommodations/features/reservations/api';

export const useCalculationPaymentStatusMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  // Handles update of reservation payment status
  const { mutate, isLoading } = useMutation(updateReservationPaymentStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Your payment is successfully saved'));
    },
    onError: () => errorToast(),
  });

  return {
    mutate,
    isLoading,
  };
};
